import React from "react";
import { cn } from "../../../common/u1/cn";
import { StarIcon } from "../../../../assets/ui/icons";

/* What the Partner Program is, on the design's dark card. */
export const MemberBenefitCard = ({
  eyebrow = "Member benefit",
  title = "See how your buyers pay, across the network.",
  body = "The Partner Program is a Member Benefit. Invite the buyers you extend credit to, we onboard and verify each one, and this dashboard shows how they pay and flags what changes. The more buyers you add, the clearer your risk picture.",
  className = "",
}) => (
  <section
    aria-labelledby="u1-benefit-heading"
    className={cn(
      "overflow-hidden rounded-[14px] p-6 text-white bg-[image:var(--plan-grad)] sm:p-7",
      className
    )}
  >
    {eyebrow && (
      <p
        className={cn(
          "m-0 mb-3 inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1",
          "text-[10.5px] font-bold uppercase tracking-[.08em] font-sans",
          "border-[var(--plan-pill-line)] bg-[var(--plan-pill-bg)] text-[var(--plan-pill-ink)]"
        )}
      >
        <StarIcon />
        {eyebrow}
      </p>
    )}

    <h3
      id="u1-benefit-heading"
      className="m-0 max-w-[620px] text-[22px] font-bold leading-[1.25] tracking-[-.01em] font-sans sm:text-[25px]"
    >
      {title}
    </h3>

    {body && (
      <p className="mt-3 mb-0 max-w-[700px] text-[13.5px] leading-[1.6] text-[var(--plan-body)] font-sans">
        {body}
      </p>
    )}
  </section>
);

export default MemberBenefitCard;
